import Job from 'umg-ember-backend/components/record-explorer/for/job';

<template><Job @records={{@model}} @recordType='job' /></template>
